import "./App.css";
import Loader from "./Components/Loader";
import { ToastContainer } from "react-toastify";
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ForgotPasswordProvider } from './Context/ForgotPasswordContext';
import { DistributorProvider } from './Context/DistributorContext';
import { CustomerMasterProvider } from './Context/CustomerMasterContext';
import { SafetyTickerProvider } from './Context/SafetyTicker';
import SchemeDiscDefAllRec from './Pages/Masters/Scheme/SchemeDiscDef/SchemeDiscDefAllRec';
import UniqueBeatID from './Pages/Masters/Customer/UniqueBeatID';
import SchemeDiscMast from './Pages/Masters/Scheme/SchemeDiscDef/SchemeDiscMast';
import AssortMentReport from './Pages/Reports/AssortMentReport';
import BannerUploadCSD from './Pages/BannerUpload/BannerUploadCSD';
import BannerUploadCSDView from './Pages/BannerUpload/BannerUploadCSDView';
import BannerUploadDB from './Pages/BannerUpload/BannerUploadDB';
import BannerUploadDBView from './Pages/BannerUpload/BannerUploadDBView';
import SKUDivisor from "./Pages/Masters/Product/SKUDivisor";
import SurchargeDefAllRecords from './Pages/Masters/Surcharge/SurchargeDefAllRecords';
import SurchargeDefinition from './Pages/Masters/Surcharge/SurchargeDefinition';
import HDILSDiscountDefinition from "./Pages/Masters/Miscellaneous/HDILSDiscountDefinition";
import AllConstructRecors from "./Pages/DBSIP/Construct/AllConstructRecors";
import Construct from "./Pages/DBSIP/Construct/Construct";
import DBSIPReport from "./Pages/DBSIP/DBSIPReport/DBSipReport";
import ExceptionHandling from "./Pages/DBSIP/ExceptionHandling/ExceptionHandling";
import LBMBrandMapping from "./Pages/DBSIP/LBMBrandandMapping/LBMBrandandMapping";
import DBSipRawData from "./Pages/DBSIP/DBSIPRawData/DBSipRawData";
import FocusBrandTargetGrowth from "./Pages/DBSIP/FocusTargetGrowth/FocusTargetGrowth";
import VolumeDefinitionDistribution from "./Pages/DBSIP/VolumeDefination/VolumeDefination";
import ThresholdRestriction from "./Pages/DBSIP/ThresholdRestriction/ThresholdRestriction";
import SIPUpload from "./Pages/DBSIP/SIPUpload/SIPUpload";
import NewAccountUpload from "./Pages/DBSIP/NewAccountUpload/NewAccountUpload";
import SIPReProcess from "./Pages/DBSIP/SIPReprocess/SIPReprocess";
import CorrectedActualUpload from "./Pages/DBSIP/CorrectedActualUpload/CorrActualUpload";
import SIPWeekDefinition from "./Pages/DBSIP/SIP Week Defination/SIPWeekDef";
import CoreNonCoreTownMapping from "./Pages/DBSIP/Core NonCore Town Mapping/CNCTownMapping";
import RNRPayoutReport from "./Pages/RNR/RNRPayoutReport/RNRPayoutReport";
const LoginLayout = lazy(() => import('./Layouts/LayoutLogin/LoginLayout'));
const MasterLayout = lazy(() => import('./Layouts/LayoutLogin/MasterLayout'));
const Dashboardindex = lazy(() => import('./Pages/Dashboard'));
const RequireAuth = lazy(() => import('./Components/RequireAuth'));
const MultipleUser = lazy(() => import('./Components/MultipleUser'));
const BannerUpload = lazy(() => import('./Pages/BannerUpload/BannerUploadCSD'));
const BannerUploadView = lazy(() => import('./Pages/BannerUpload/BannerUploadCSDView'));
const AutomotiveManualBilling = lazy(() => import('./Pages/AutomotiveManualBilling'));
const SchemeDiscountDefinition = lazy(() => import('./Pages/Masters/Scheme/SchemeDiscDef/SchemeDiscountDefinition'));
const SSRApproval = lazy(() => import('./Pages/Masters/SSR/SSRApproval'));
const RuralKYCCustomerApproval = lazy(() => import('./Pages/Masters/Customer/RuralKYCCustomerApproval/RuralKYCCustomerApproval'));
const CustomerInformation = lazy(() => import('./Pages/Masters/Customer/RuralKYCCustomerApproval/CustomerInformation'));
const SegmentChangeReactivationApprovalForCSD = lazy(() => import('./Pages/Rural/CustomerSegmentTownApprovalforCSD/SegmentChangeReactivationApprovalForCSD'));
const BasketProductDefinition = lazy(() => import('./Pages/Masters/Product/BasketProductDefinition/BasketProductDefinition'));
const BasketProductDefinitionView = lazy(() => import('./Pages/Masters/Product/BasketProductDefinition/BasketProductDefinitionView'));
const OnInvoiceFOC = lazy(() => import('./Pages/Masters/Scheme/OnInvoiceFOC/OnInvoiceFOC'));
const OnInvoiceFOCView = lazy(() => import('./Pages/Masters/Scheme/OnInvoiceFOC/OnInvoiceFOCView'));
const JCBUserDetails = lazy(() => import('./Pages/Reports/JCB/JCBUserDetails'));
const RSECustomerReport = lazy(() => import('./Pages/Rural/RSECustomerReport'));
const RSEReports = lazy(() => import('./Pages/Rural/RSEReports'));
const JCBCouponReconciliation = lazy(() => import('./Pages/Reports/JCB/JCBCouponReconciliation'));
const JCBCouponSearch = lazy(() => import('./Pages/Reports/JCB/JCBCouponSearch'));
const JCBTransactionalDetails = lazy(() => import('./Pages/Reports/JCB/JCBTransactionalDetails'));
const DistributorsOnboarding = lazy(() => import('./Pages/DistributorsOnboarding/DistributorsOnboarding'));
const DistributorsOnboardingView = lazy(() => import('./Pages/DistributorsOnboarding/DistributorsOnboardingView'));
const Mapping = lazy(() => import('./Pages/Masters/Miscellaneous/SalesTeamMaster/Mapping'));
const DesignationMaster = lazy(() => import('./Pages/Masters/Designation/DesignationMaster/DesignationMaster'));
const DesignationMasterView = lazy(() => import('./Pages/Masters/Designation/DesignationMaster/DesignationMasterView'));
const DistributorMapping = lazy(() => import('./Pages/Masters/Designation/DesignationMaster/DistributorMapping'));
const DownloadDetailMonitor = lazy(() => import('./Pages/Reports/DownloadDetailMonitor'));
const KYCExceptionApproval = lazy(() => import('./Pages/Masters/Customer/KYCExceptionApproval'));
const HDKYCApproval = lazy(() => import('./Pages/Masters/Customer/HDKYCApproval'));
const StockAdjustmentApprovalForCSD = lazy(() => import('./Pages/Rural/StockAdjustmentApprovalForCSD'));
const StockNorm = lazy(() => import('./Pages/InventoryManagement/StockNorm'));
const StockAdjustmentApproval = lazy(() => import('./Pages/InventoryManagement/StockAdjustmentApproval'));
const DestroyApproval = lazy(() => import('./Pages/InventoryManagement/Collateral/DestroyApproval'));
const APlusProduct = lazy(() => import('./Pages/InventoryManagement/APlusProduct'));
const NormWeightageSetting = lazy(() => import('./Pages/InventoryManagement/NormWeightageSetting'));
const FOCApproval = lazy(() => import('./Pages/QRM/FOCApproval/FOCApproval'));
const FOCApprovalView = lazy(() => import('./Pages/QRM/FOCApproval/FOCApprovalView'));
const ABCDefinition = lazy(() => import('./Pages/InventoryManagement/ABCDefinition'));
const ABCView = lazy(() => import('./Pages/InventoryManagement/ABCView'));
const NewProductIntroduction = lazy(() => import('./Pages/InventoryManagement/NewProductIntroduction'));
const NormParameter = lazy(() => import('./Pages/InventoryManagement/NormParameter'));
const StockNormBulkUpload = lazy(() => import('./Pages/InventoryManagement/StockNormBulkUpload'));
const CFAPromoMapping = lazy(() => import('./Pages/InventoryManagement/CFAPromoMapping'));
const NormCalculationProcess = lazy(() => import('./Pages/InventoryManagement/NormCalculationProcess'));
const FreezedCNFOCReport = lazy(() => import('./Pages/QRM/Reports/FreezedCNFOCReport'));
const SurveyFeedback = lazy(() => import('./Pages/Helpdesk/SurveyFeedback'));
const SGRBrandEligibility = lazy(() => import('./Pages/SGRBrand/SGRBrandEligibility'));
const SGRBrandDataView = lazy(() => import('./Pages/SGRBrand/SGRBrandDataView'));
const SGRBrandDataViewPreview = lazy(() => import('./Pages/SGRBrand/SGRBrandDataViewPreview'));
const DispatchAddressReport = lazy(() => import('./Pages/InventoryManagement/Collateral/DispatchAddressReport'));
const StatusDashboard = lazy(() => import('./Pages/InventoryManagement/Collateral/StatusDashboard'));
const NonInventoryCategoryMaster = lazy(() => import('./Pages/InventoryManagement/Collateral/NonInventoryCategoryMaster'));
const PurchaseOrderGeneration = lazy(() => import('./Pages/InventoryManagement/PurchaseOrderGeneration'));
const NonInventoryGRNDataToExcel = lazy(() => import('./Pages/Reports/NonInventoryGRNDataToExcel'));
const GRNDiscountDataToExcel = lazy(() => import('./Pages/Reports/GRNDiscountDataToExcel'));
const CustomerMetricReport = lazy(() => import('./Pages/Reports/CustomerMetricReport'));
const ContractPricingReport = lazy(() => import('./Pages/Reports/ContractPricingReport'));
const CouponReportToExcel = lazy(() => import('./Pages/Reports/CouponReportToExcel'));
const DeliveryChallanReport = lazy(() => import('./Pages/Reports/DeliveryChallanReport'));
const FOCReport = lazy(() => import('./Pages/Reports/FOCReport'));
const FOCTrackerReport = lazy(() => import('./Pages/Reports/FOCTrackerReport'));
const CSDReports = lazy(() => import('./Pages/Rural/CSDReports'));
const ClassificationBeatFrequency = lazy(() => import('./Pages/Masters/Customer/ClassificationBeatFrequency'));
const AdminReports = lazy(() => import('./Pages/AdminReports'));
const DownloadPriceList = lazy(() => import('./Pages/PriceList/DownloadPriceList'));
const PriceListUploadTemplate = lazy(() => import('./Pages/PriceList/PriceListUploadTemplate'));
const GoodsInTransit = lazy(() => import('./Pages/Reports/Stock/GoodsInTransit'));
const StockAdjustment = lazy(() => import('./Pages/Reports/Stock/StockAdjustment'));
const StockDailyDetail = lazy(() => import('./Pages/Reports/Stock/StockDailyDetail'));
const StockInHand = lazy(() => import('./Pages/Reports/Stock/StockInHand'));
const StockMonthlyDetail = lazy(() => import('./Pages/Reports/Stock/StockMonthlyDetail'));
const OrderReceivedVsOrderInvoiced = lazy(() => import('./Pages/Reports/Sales/OrderReceivedVsOrderInvoiced'));
const SalesAgeingReport = lazy(() => import('./Pages/Reports/Sales/SalesAgeingReport'));
const InvoiceDataToExcelHOUsers = lazy(() => import('./Pages/Reports/Sales/InvoiceDataToExcelHOUsers'));
const SKUDiscountDataToExcel = lazy(() => import('./Pages/Reports/Sales/SKUDiscountDataToExcel'));
const InvoiceDataToExcel = lazy(() => import('./Pages/Reports/Sales/InvoiceDataToExcel'));
const CombinedReportForUrbanRural = lazy(() => import('./Pages/Reports/Sales/CombinedReportForUrbanRural'));
const CreditNoteAdjustment = lazy(() => import('./Pages/Reports/Sales/CreditNoteAdjustment'));
const FOCCreation = lazy(() => import('./Pages/InterfacesOutputs/FOCCreation'));
const BaseProductDefinition = lazy(() => import('./Pages/Masters/Product/BaseProductDefinition'));
const CastrolEmployee = lazy(() => import('./Pages/UserManagement/CastrolEmployee/CastrolEmployee'));
const CastrolEmployeeView = lazy(() => import('./Pages/UserManagement/CastrolEmployee/CastrolEmployeeView'));
const CastrolUser = lazy(() => import('./Pages/UserManagement/CastrolUser/CastrolUser'));
const CastrolUserView = lazy(() => import('./Pages/UserManagement/CastrolUser/CastrolUserView'));
const SegmentChannelMapping = lazy(() => import('./Pages/InterfacesOutputs/SegmentChannelMapping'));
const TargetSettings = lazy(() => import('./Pages/InterfacesOutputs/TargetSettings'));
const Product = lazy(() => import('./Pages/Masters/Product/Product/Product'));
const ProductView = lazy(() => import('./Pages/Masters/Product/Product/ProductView'));
const ProductNonInventory = lazy(() => import('./Pages/Masters/Product/ProductNonInventory/ProductNonInventory'));
const ProductNonInventoryView = lazy(() => import('./Pages/Masters/Product/ProductNonInventory/ProductNonInventoryView'));
const SurveyForm = lazy(() => import('./Pages/Helpdesk/SurveyForm/SurveyForm'));
const SurveyFormView = lazy(() => import('./Pages/Helpdesk/SurveyForm/SurveyFormView'));
const RILAMMaster = lazy(() => import('./Pages/InterfacesOutputs/OEMInterface/RILAMMaster'));
const OEMErrorDownload = lazy(() => import('./Pages/InterfacesOutputs/OEMInterface/OEMErrorDownload'));
const SalesTeamMapping = lazy(() => import('./Pages/Masters/Miscellaneous/SalesTeamMapping'));
const WorkshopDiscountRestrictionMapping = lazy(() => import('./Pages/Masters/Miscellaneous/WorkshopDiscountRestrictionMapping'));
const WorkshopOutletRestriction = lazy(() => import('./Pages/Masters/Customer/WorkshopOutletRestriction'));
const IssueLogger = lazy(() => import('./Pages/Helpdesk/IssueLogger'));
const SLAMonitor = lazy(() => import('./Pages/Helpdesk/SLAMonitor'));
const SSRMasterReport = lazy(() => import('./Pages/Masters/SSR/SSRMasterReport'));
const SSRTownMappingReport = lazy(() => import('./Pages/Masters/SSR/SSRTownMappingReport'));
const ServiceInvoiceApproval = lazy(() => import('./Pages/Masters/SSR/ServiceInvoiceApproval'));
const SSRIncentiveMapping = lazy(() => import('./Pages/Masters/SSR/SSRIncentiveMapping'));
const SSRToTownMapping = lazy(() => import('./Pages/Masters/SSR/SSRToTownMapping'));
const WorkshopOutletMapping = lazy(() => import('./Pages/Masters/Customer/WorkshopOutletMapping/WorkshopOutletMapping'));
const WorkshopOutletMappingView = lazy(() => import('./Pages/Masters/Customer/WorkshopOutletMapping/WorkshopOutletMappingView'));
const CastrolUserGroup = lazy(() => import('./Pages/UserManagement/CastrolUserGroup/CastrolUserGroup'));
const CastrolUserGroupView = lazy(() => import('./Pages/UserManagement/CastrolUserGroup/CastrolUserGroupView'));
const Privilege = lazy(() => import('./Pages/UserManagement/CastrolUserGroup/Privilege'));
const TownBulkUpload = lazy(() => import('./Pages/Masters/TownBulkUpload'));
const CMTEmployeeMaster = lazy(() => import('./Pages/Masters/CMTEmployeeMaster'));
const PriceVariation = lazy(() => import('./Pages/Masters/PriceVariation'));
const ForecastUpload = lazy(() => import('./Pages/Masters/Miscellaneous/ForecastUpload'));
const Distributor = lazy(() => import('./Pages/Masters/Distributor/Distributor/Distributor'));
const DistributorView = lazy(() => import('./Pages/Masters/Distributor/Distributor/DistributorView'));
const TownReallocationView = lazy(() => import('./Pages/Masters/Distributor/TownReallocation/TownReallocationView'));
const CensusGeographyUpload = lazy(() => import('./Pages/Masters/Miscellaneous/CensusGeographyUpload'));
const CreditNoteAdjustmentMap = lazy(() => import('./Pages/Masters/Miscellaneous/CreditNoteAdjustmentMap'));
const CastrolQuarterConfig = lazy(() => import('./Pages/UserManagement/CastrolQuarterConfig'));
const TownDefinition = lazy(() => import('./Pages/Masters/TownDefinition/TownDefinition'));
const TownDefinitionView = lazy(() => import('./Pages/Masters/TownDefinition/TownDefinitionView'));
const VendorMaster = lazy(() => import('./Pages/UserManagement/VendorMaster/VendorMaster'));
const VendorMasterView = lazy(() => import('./Pages/UserManagement/VendorMaster/VendorMasterView'));
const DocumentAdjustment = lazy(() => import('./Pages/Masters/Customer/DocumentAdjustmentApproval/DocumentAdjustment'));
const RestrictionOnReactivation = lazy(() => import('./Pages/Masters/Customer/RestrictionOnReactivation'));
const DesignationDataDownload = lazy(() => import('./Pages/Masters/Designation/DesignationDataDownload'));
const OEMProductMapping = lazy(() => import('./Pages/Masters/Miscellaneous/OEMProductMapping'));
const CreditNoteBulkUpload = lazy(() => import('./Pages/Masters/Miscellaneous/CreditNoteBulkUpload'));
const CustomerView = lazy(() => import('./Pages/Masters/Customer/Customer/CustomerView'))
const DocumentAdjustmentView = lazy(() => import('./Pages/Masters/Customer/DocumentAdjustmentApproval/DocumentAdjustmentView'));
const Role = lazy(() => import('./Pages/Masters/Designation/Role/Role'));
const RoleView = lazy(() => import('./Pages/Masters/Designation/Role/RoleView'));
const SegmentDiscount = lazy(() => import('./Pages/Masters/Miscellaneous/SegmentDiscountMapping/SegmentDiscount'));
const SegmentDiscountView = lazy(() => import('./Pages/Masters/Miscellaneous/SegmentDiscountMapping/SegmentDiscountView'));
const InvoicePunch = lazy(() => import('./Pages/Masters/Miscellaneous/InvoicePunch'));
const KYCException = lazy(() => import('./Pages/Masters/Customer/KYCException'));
const KYCTimeline = lazy(() => import('./Pages/Masters/Customer/KYCTimeline'));
const ExpiredSummary = lazy(() => import('./Pages/Masters/Customer/ExpiredSummary'));
const Customer = lazy(() => import('./Pages/Masters/Customer/Customer/Customer'));
const ExpiredDistributorStockSale = lazy(() => import('./Pages/Masters/Distributor/ExpiredDistributorStockSale'));
const BURegionAutomotive = lazy(() => import('./Pages/Masters/Distributor/BURegionAutomotive'));
const TownRecategorization = lazy(() => import('./Pages/Masters/Distributor/TownRecategorization'));
const TownReallocation = lazy(() => import('./Pages/Masters/Distributor/TownReallocation/TownReallocation'));
const TownReallocationHistory = lazy(() => import('./Pages/Masters/Distributor/TownReallocationHistory'));
const TownDistributorMapping = lazy(() => import('./Pages/Masters/Distributor/TownDistributorMapping'));
const SegmentAudit = lazy(() => import('./Pages/Masters/Customer/CustomerSegmentAudit'));
const VerificationTimeline = lazy(() => import('./Pages/Masters/Customer/VerificationTimeline'));
const CustomerAdditionalClassification = lazy(() => import('./Pages/Masters/Customer/CustomerAdditionalClassification'));
const ASMBeatFrequencyPlanning = lazy(() => import('./Pages/Masters/Customer/ASMBeatFrequencyPlanning'));
const CustomerBulkExpiryActivation = lazy(() => import('./Pages/Masters/Customer/CustomerBulkExpiryActivation'));
const SegmentChangeReactivationApproval = lazy(() => import('./Pages/Masters/Customer/CustomerSegmentTownApproval/SegmentChangeReactivationApproval'));
const TownReallocationRecategorizationApproval = lazy(() => import('./Pages/Masters/Customer/CustomerSegmentTownApproval/TownReallocationRecategorizationApproval/TownReallocationRecategorizationApproval'));
const TownReallocationRecategorizationApprovalAllRecords = lazy(() => import('./Pages/Masters/Customer/CustomerSegmentTownApproval/TownReallocationRecategorizationApproval/TownReallocationRecategorizationApprovalAllRecords'));
const CNFOCTransfer = lazy(() => import('./Pages/Masters/Customer/CustomerSegmentTownApproval/CNFOCTransfer'));
const CNFOCTransferRequestApproval = lazy(() => import('./Pages/Masters/Customer/CustomerSegmentTownApproval/CNFOCTransferRequestApproval'));
const SMSDeliveryStatusReport = lazy(() => import('./Pages/Masters/Customer/SMSDeliveryStatusReport'));
const SegmentCodeSetting = lazy(() => import('./Pages/Masters/Customer/SegmentCodeSetting'));
const SpecialCodeUpload = lazy(() => import('./Pages/Masters/Customer/SpecialCodeUpload'));
const WorkshopOutletIdRestrictionAccessMapping = lazy(() => import('./Pages/Masters/Customer/WorkshopOutletIdRestrictionAccessMapping'));
const SchemeCFLDiscountDefinition = lazy(() => import('./Pages/Masters/Scheme/SchemeCFLDiscountDefinition'));
const SchemeDiscountDefinitionOld = lazy(() => import('./Pages/Masters/Scheme/SchemeDiscountDefinitionOld'));
const SchemeDefinition = lazy(() => import('./Pages/Masters/Scheme/SchemeDefinition'));
const ReasonRelated = lazy(() => import('./Pages/Masters/Miscellaneous/ReasonRelated/ReasonRelated'));
const ReasonRelatedView = lazy(() => import('./Pages/Masters/Miscellaneous/ReasonRelated/ReasonRelatedView'));
const WorkshopDiscountDefinition = lazy(() => import('./Pages/Masters/Miscellaneous/WorkshopDiscountDefinition'));
const NONInventoryGRNCreation = lazy(() => import('./Pages/Masters/Miscellaneous/NONInventoryGRNCreation'));
const CollateralReallocationApproval = lazy(() => import('./Pages/Masters/Miscellaneous/CollateralReallocationApproval'));
const PrintMessageDefinition = lazy(() => import('./Pages/Masters/Printing/PrintMessageDefinition'));
const PrintMessageDefinitionView = lazy(() => import('./Pages/Masters/Printing/PrintMessageDefinitionView'));
const PrintMessageTranslation = lazy(() => import('./Pages/Masters/Printing/PrintMessageTranslation'));
const RedeemedCouponTransfer = lazy(() => import('./Pages/Masters/Miscellaneous/RedeemedCouponTransfer'));
const SafetyTicker = lazy(() => import('./Pages/Masters/Miscellaneous/SafetyTicker/SafetyTicker'));
const SafetyTickerView = lazy(() => import('./Pages/Masters/Miscellaneous/SafetyTicker/SafetyTickerView'));
const SalesTeamMaster = lazy(() => import('./Pages/Masters/Miscellaneous/SalesTeamMaster/SalesTeamMaster'));
const SalesTeamMasterView = lazy(() => import('./Pages/Masters/Miscellaneous/SalesTeamMaster/SalesTeamMasterView'));
const DSRUpload = lazy(() => import('./Pages/InterfacesOutputs/DSRUpload'));
const RuralKYCSegmentMapping = lazy(() => import('./Pages/InterfacesOutputs/RuralKYCSegmentMapping'));
const OEMMappingUpload = lazy(() => import('./Pages/InterfacesOutputs/OEMInterface/OEMMappingUpload'));
const OEMMasterSegmentMapping = lazy(() => import('./Pages/InterfacesOutputs/OEMInterface/OEMMasterSegmentMapping'));
const SpecialPricesUpload = lazy(() => import('./Pages/InterfacesOutputs/OEMInterface/SpecialPricesUpload'));
const FreeProducts = lazy(() => import('./Pages/InterfacesOutputs/FreeProducts'));
const CNApproval = lazy(() => import('./Pages/QRM/CNApproval/CNApproval'));
const CNApprovalView = lazy(() => import('./Pages/QRM/CNApproval/CNApprovalView'));
const HolidayList = lazy(() => import('./Pages/InterfacesOutputs/HolidayList'));
const QRMStatusReport = lazy(() => import('./Pages/QRM/Reports/QRMStatusReport'));
const SSRType = lazy(() => import('./Pages/Masters/SSR/SSRType'));
const CreateSSR = lazy(() => import('./Pages/Masters/SSR/CreateSSR/CreateSSR'));
const CreateSSRView = lazy(() => import('./Pages/Masters/SSR/CreateSSR/CreateSSRView'));
const SalesMonthlyReport = lazy(() => import('./Pages/Reports/Sales/SalesMonthlyReport'));
const SalesPeriodicReport = lazy(() => import('./Pages/Reports/Sales/SalesPeriodicReport'));
const SalesDailyReport = lazy(() => import('./Pages/Reports/Sales/SalesDailyReport'));
const SalesWeeklyReport = lazy(() => import('./Pages/Reports/Sales/SalesWeeklyReport'));
const SalesQuarterlyReport = lazy(() => import('./Pages/Reports/Sales/SalesQuarterlyReport'));
const TownwiseSalesMonthlyReport = lazy(() => import('./Pages/Reports/Sales/TownwiseSalesMonthlyReport'));
const SalesComparisonReport = lazy(() => import('./Pages/Reports/Sales/SalesComparisonReport'));
const GRNDatatoExcel = lazy(() => import('./Pages/Reports/GRNDatatoExcel'));
const ReportValueAccessMapping = lazy(() => import('./Pages/Reports/ReportValueAccessMapping'));
const ChangeRequestReport = lazy(() => import('./Pages/Reports/ChangeRequestReport'));
const NonInventoryReport = lazy(() => import('./Pages/Reports/NonInventoryReport'));
const PIDwiseTargetUpload = lazy(() => import('./Pages/Rural/PIDwiseTargetUpload'));
const RuralTownTagging = lazy(() => import('./Pages/Rural/RuralTownTagging'));
const KYCApproval = lazy(() => import('./Pages/Masters/Customer/KYCApproval'));
const NonKYCToKYCApproval = lazy(() => import('./Pages/Masters/Customer/NonKYCToKYCApproval'));
const SchemeAutomation = lazy(() => import('./Pages/SchemeAutomation'))
const AnmolRatan = lazy(() => import('./Pages/AnmolRatan'));
const FastScan = lazy(() => import('./Pages/FastScan'));
const RewardsAndRebate = lazy(() => import('./Pages/RewardsAndRebate'));
const AudienceDefinition = lazy(() => import('./Pages/RNR/AudienceDefinition/AudienceDefinition'));
const ChannelDefinition = lazy(() => import('./Pages/RNR/ChannelDefinition/ChannelDefinition'));
const LBMDefinition = lazy(() => import('./Pages/RNR/LBMDefinition/LBMDefinition'));
const CategoryHeadLvlMaxDisc = lazy(() => import('./Pages/RNR/CategoryHeadLvlMaxDisc/CategoryHeadLvlMaxDisc'));
const DBDiscFactorMapping = lazy(() => import('./Pages/RNR/DBDiscFactorMapping/DBDiscFactorMapping'));
const CategoryStreamMapping = lazy(() => import('./Pages/RNR/CategoryStreamMapping/CategoryStreamMapping'));
const ChannelCategoryUserMapping = lazy(() => import('./Pages/RNR/ChannelCategoryUserMapping/ChannelCategoryUserMapping'));
const ChannelDefUserMapping = lazy(() => import('./Pages/RNR/ChannelDefUserMapping/ChannelDefUserMapping'));
const ChannelOutletMapping = lazy(() => import('./Pages/RNR/ChannelOutletMapping/ChannelOutletMapping'));
const DBToCategoryMapping = lazy(() => import('./Pages/RNR/DBToCategoryMapping/DBToCategoryMapping'));
const IndustrialDBTurnOverUpload = lazy(() => import('./Pages/RNR/IndustrialDBTurnOverUpload/IndustrialDBTurnOverUpload'));
const RewardsRebateStatusReport = lazy(() => import('./Pages/RNR/RewardsRebateStatusReport/RewardsRebateStatusReport'));
const AllCategoryRecord = lazy(() => import('./Pages/RNR/AllCategoryRecord/AllCategoryRecord'));
const ASMRSMApprovalDBScoreCrad = lazy(() => import('./Pages/RNR/ASMRSMApprovalDBScoreCrad/ASMRSMApprovalDBScoreCrad'));
const RSMPlanningToolDBScorecard = lazy(() => import('./Pages/RNR/RSMPlanningToolDBScorecard/RSMPlanningToolDBScorecard'));
const ASMPlaningToolDBScoreCard = lazy(() => import('./Pages/RNR/ASMPlaningToolDBScoreCard/ASMPlaningToolDBScoreCard'));
const ASMPlanningAllRecords = lazy(() => import('./Pages/RNR/ASMPlanningAllRecords/ASMPlanningAllRecords'));
const RSMPlanningAllRecords = lazy(() => import('./Pages/RNR/RSMPlanningAllRecords/RSMPlanningAllRecords'));
const ASMRSMApprovalAllRecords = lazy(() => import('./Pages/RNR/ASMRSMApprovalAllRecords/ASMRSMApprovalAllRecords'));
const CategoryDefinition = lazy(() => import('./Pages/RNR/CategoryDefinition/CategoryDefinition'));
const DBSip = lazy(() => import('./Pages/DBSip'));
const Login = lazy(() => import("./Pages/Login/Login"));
const CustomerUploadDB = lazy(() => import('./Pages/Masters/DealerAppAdmin/CustomerUploadDB'));
const CustomerUploadCSD = lazy(() => import('./Pages/Masters/DealerAppAdmin/CustomerUploadCSD'));



function App() {
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        rtl={false}
        pauseOnFocusLoss
        closeButton={false}
        draggable
        pauseOnHover
      />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/MultipleUser" element={<MultipleUser />} />
          <Route path="/" element={<LoginLayout />}>
            <Route
              index
              element={
                <ForgotPasswordProvider>
                  <Login />
                </ForgotPasswordProvider>
              }
            />
          </Route>
          <Route element={<RequireAuth />}>
            <Route element={<MasterLayout />}>
              {/* Redirection */}
              <Route path="/SchemeAutomation" element={<SchemeAutomation />} />
              <Route path="/FastScan" element={<FastScan />} />
              <Route path="/AnmolRatan" element={<AnmolRatan />} />
              <Route path="/DBSip" element={<DBSip />} />
              <Route path="/RewardsAndRebate" element={<RewardsAndRebate />} />
              {/* MASTER LAYOUT START HERE */}
              <Route path="/Dashboard" element={<Dashboardindex />} />
              <Route path="/" element={<Navigate to="/dashboard" />} />
              {/* Distributor Start */}
              <Route
                path="/Master/Distributor/ExpiredDistributorStockSale"
                element={<ExpiredDistributorStockSale />}
              ></Route>
              <Route
                path="/Master/Distributor/TownDistributorMapping"
                element={<TownDistributorMapping />}
              ></Route>
              <Route
                path="/Master/Distributor/TownReallocationHistory"
                element={<TownReallocationHistory />}
              ></Route>
              <Route
                path="/Master/Distributor/TownReallocation"
                element={<TownReallocation />}
              ></Route>
              <Route
                path="/Master/Distributor/TownReallocation/View"
                element={<TownReallocationView />}
              ></Route>
              <Route
                path="/Master/Distributor/TownRecategorization"
                element={<TownRecategorization />}
              ></Route>
              <Route
                path="/Master/Distributor/BURegionForAutomotiveDistributors"
                element={<BURegionAutomotive />}
              ></Route>
              <Route
                path="/Master/Distributor/Distributor"
                element={
                  <DistributorProvider>
                    <Distributor />
                  </DistributorProvider>
                }
              />
              <Route
                path="/Master/Distributor/Distributor/View"
                element={
                  <DistributorProvider>
                    <DistributorView />
                  </DistributorProvider>
                }
              />

              {/* Distributor End */}

              {/* Customer Start */}
              <Route
                path="/Master/Customer/Customer"
                element={
                  <CustomerMasterProvider>
                    <Customer />
                  </CustomerMasterProvider>
                }
              ></Route>
              <Route
                path="/Master/Customer/Customer/View"
                element={
                  <CustomerMasterProvider>
                    <CustomerView />
                  </CustomerMasterProvider>
                }
              ></Route>
              <Route
                path="/Master/Customer/CustomerSegmentTownApproval/SegmentChangeReactivationApproval"
                element={<SegmentChangeReactivationApproval />}
              ></Route>
              <Route
                path="/Master/Customer/CustomerSegmentTownApproval/TownReallocationRecategorizationApproval"
                element={<TownReallocationRecategorizationApproval />}
              ></Route>
              <Route
                path="/Master/Customer/CustomerSegmentTownApproval/TownReallocationRecategorizationApproval/AllRecords"
                element={<TownReallocationRecategorizationApprovalAllRecords />}
              ></Route>
              <Route
                path="/Master/Customer/CustomerSegmentTownApproval/CNFOCTransfer"
                element={<CNFOCTransfer />}
              ></Route>
              <Route
                path="/Master/Customer/CustomerSegmentTownApproval/CNFOCTransferRequestApproval"
                element={<CNFOCTransferRequestApproval />}
              ></Route>
              <Route
                path="/Master/Customer/SMSDeliveryStatusReport"
                element={<SMSDeliveryStatusReport />}
              ></Route>
              <Route
                path="/Master/Customer/SegmentCodeSetting"
                element={<SegmentCodeSetting />}
              ></Route>
              <Route
                path="/Master/Customer/SpecialCodeUpload"
                element={<SpecialCodeUpload />}
              ></Route>
              <Route
                path="/Master/Customer/WorkshopOutletIdRestrictionAccessMapping"
                element={<WorkshopOutletIdRestrictionAccessMapping />}
              ></Route>
              <Route
                path="/Master/Customer/ExpiredCustomerSummary"
                element={<ExpiredSummary />}
              ></Route>
              <Route
                path="/Master/Customer/KYCTimelineMaster"
                element={<KYCTimeline />}
              ></Route>
              <Route
                path="/Master/Customer/KYCExceptionReport"
                element={<KYCException />}
              ></Route>
              <Route
                path="/Master/Customer/DocumentAdjustmentApproval"
                element={<DocumentAdjustment />}
              ></Route>
              <Route
                path="/Master/Customer/DocumentAdjustmentApproval/View"
                element={<DocumentAdjustmentView />}
              ></Route>
              {/* <Route path='/Master/Product/ProductDefinition' element={<ProductDefinition />}></Route> */}
              <Route
                path="/Master/Customer/RestrictionOnReactivation"
                element={<RestrictionOnReactivation />}
              ></Route>
              <Route
                path="/Master/Customer/SegmentAudit"
                element={<SegmentAudit />}
              ></Route>
              <Route
                path="/Master/Customer/VerificationTimeline"
                element={<VerificationTimeline />}
              ></Route>
              <Route
                path="/Master/Customer/ASMBeatFrequencyPlanning"
                element={<ASMBeatFrequencyPlanning />}
              ></Route>
              <Route
                path="/Master/Customer/CustomerAdditionalClassification"
                element={<CustomerAdditionalClassification />}
              ></Route>
              <Route
                path="/Master/Customer/CustomerBulkExpiryActivation"
                element={<CustomerBulkExpiryActivation />}
              ></Route>
              <Route
                path="/Master/Customer/WorkshopOutletRestriction"
                element={<WorkshopOutletRestriction />}
              ></Route>
              <Route
                path="/Master/Customer/WorkshopOutletMapping"
                element={<WorkshopOutletMapping />}
              ></Route>
              <Route
                path="/Master/Customer/KYCApproval"
                element={<KYCApproval />}
              ></Route>
              <Route
                path="/Master/Customer/NonKYCToKYCApproval"
                element={<NonKYCToKYCApproval />}
              ></Route>
              <Route
                path="/Master/Customer/WorkshopOutletMapping/View"
                element={<WorkshopOutletMappingView />}
              ></Route>
              <Route
                path="/Master/Customer/CustomerClassification&BeatFrequency"
                element={<ClassificationBeatFrequency />}
              ></Route>
              <Route
                path="/Master/Customer/RuralKYCCustomerApproval"
                element={<RuralKYCCustomerApproval />}
              ></Route>
              <Route
                path="/Master/Customer/RuralKYCCustomerApproval/ContactInformation"
                element={<CustomerInformation />}
              ></Route>
              <Route
                path="/Master/Customer/HDKYCApproval"
                element={<HDKYCApproval />}
              ></Route>
              <Route
                path="/Master/Customer/KYCExceptionApproval"
                element={<KYCExceptionApproval />}
              ></Route>
              <Route
                path="/Master/Customer/UniqueBeatID"
                element={<UniqueBeatID />}
              ></Route>
              {/* Customer End */}

              {/* Product Start */}
              <Route
                path="/Master/Product/Product"
                element={<Product />}
              ></Route>
              <Route
                path="/Master/Product/Product/View"
                element={<ProductView />}
              ></Route>
              <Route
                path="/Master/Product/ProductNonInventory"
                element={<ProductNonInventory />}
              ></Route>
              <Route
                path="/Master/Product/ProductNonInventory/View"
                element={<ProductNonInventoryView />}
              ></Route>
              <Route
                path="/Master/Product/BaseProductDefinition"
                element={<BaseProductDefinition />}
              ></Route>
              <Route
                path="/Master/Product/BasketProductDefinition"
                element={<BasketProductDefinition />}
              ></Route>
              <Route
                path="/Master/Product/BasketProductDefinition/View"
                element={<BasketProductDefinitionView />}
              ></Route>
              <Route
                path="/Master/Product/SKUDivisor"
                element={<SKUDivisor />}
              />
              {/* Product End */}

              {/* Designation Start */}
              <Route
                path="/Master/Designation/DesignationDataDownload"
                element={<DesignationDataDownload />}
              ></Route>
              <Route path="/Master/Designation/Role" element={<Role />}></Route>
              <Route
                path="/Master/Designation/Role/View"
                element={<RoleView />}
              ></Route>
              <Route
                path="/Master/Designation/DesignationMaster"
                element={<DesignationMaster />}
              ></Route>
              <Route
                path="/Master/Designation/DesignationMaster/View"
                element={<DesignationMasterView />}
              ></Route>
              <Route
                path="/Master/Designation/Mapping"
                element={<DistributorMapping />}
              ></Route>
              {/* Designation End */}

              {/* Scheme Start */}
              <Route path='/Master/Scheme/SchemeCFLDiscountDefinition' element={<SchemeCFLDiscountDefinition />}></Route>
              <Route path='/Master/Scheme/SchemeDiscountDefinitionOld' element={<SchemeDiscountDefinitionOld />}></Route>
              {/* <Route path='/Master/Scheme/SchemeDiscountDefinition' elemen\t={<SchemeDiscountDefinition />}></Route> */}
              <Route path='/Master/Scheme/SchemeDiscDefAllRec' element={<SchemeDiscDefAllRec />}></Route>
              <Route path='/Master/Scheme/SchemeDefinition' element={<SchemeDefinition />}></Route>
              <Route path='/Master/Scheme/OnInvoiceFOC' element={<OnInvoiceFOC />}></Route>
              <Route path='/Master/Scheme/OnInvoiceFOC/View' element={<OnInvoiceFOCView />}></Route>
              <Route path='/Master/Scheme/SchemeDiscountDefinition' element={<SchemeDiscMast />}></Route>
              {/* Scheme End */}

              {/* Miscellaneous Start */}
              <Route
                path="/Master/Miscellaneous/ReasonRelated"
                element={<ReasonRelated />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/ReasonRelated/View"
                element={<ReasonRelatedView />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/InvoicePunchData"
                element={<InvoicePunch />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/OEMProductMapping"
                element={<OEMProductMapping />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/CreditNoteBulkUpload"
                element={<CreditNoteBulkUpload />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/SegmentDiscountMapping"
                element={<SegmentDiscount />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/SegmentDiscountMapping/View"
                element={<SegmentDiscountView />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/WorkshopDiscountDefinition"
                element={<WorkshopDiscountDefinition />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/NONInventoryGRNCreation"
                element={<NONInventoryGRNCreation />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/CollateralReallocationApproval"
                element={<CollateralReallocationApproval />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/ForecastUpload"
                element={<ForecastUpload />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/CensusGeographyUpload"
                element={<CensusGeographyUpload />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/CreditNoteAdjustmentRestrictionMapping"
                element={<CreditNoteAdjustmentMap />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/RedeemedCouponTransfer"
                element={<RedeemedCouponTransfer />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/HD-ILSDiscountDefinitionReport"
                element={<HDILSDiscountDefinition />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/ProductBranding"
                element={
                  <SafetyTickerProvider>
                    <SafetyTicker />
                  </SafetyTickerProvider>
                }
              ></Route>
              <Route
                path="/Master/Miscellaneous/ProductBranding/View"
                element={
                  <SafetyTickerProvider>
                    <SafetyTickerView />
                  </SafetyTickerProvider>
                }
              ></Route>
              <Route
                path="/Master/Miscellaneous/SalesTeamMaster"
                element={<SalesTeamMaster />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/SalesTeamMaster/View"
                element={<SalesTeamMasterView />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/SalesTeamMaster/Mapping"
                element={<Mapping />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/SalesTeamMapping"
                element={<SalesTeamMapping />}
              ></Route>
              <Route
                path="/Master/Miscellaneous/WorkshopDiscountRestrictionMapping"
                element={<WorkshopDiscountRestrictionMapping />}
              ></Route>
              <Route path='/Master/Miscellaneous/ReasonRelated' element={<ReasonRelated />}></Route>
              <Route path='/Master/Miscellaneous/ReasonRelated/View' element={<ReasonRelatedView />}></Route>
              <Route path='/Master/Miscellaneous/InvoicePunchData' element={<InvoicePunch />}></Route>
              <Route path='/Master/Miscellaneous/OEMProductMapping' element={<OEMProductMapping />}></Route>
              <Route path='/Master/Miscellaneous/CreditNoteBulkUpload' element={<CreditNoteBulkUpload />}></Route>
              <Route path='/Master/Miscellaneous/SegmentDiscountMapping' element={<SegmentDiscount />}></Route>
              <Route path='/Master/Miscellaneous/SegmentDiscountMapping/View' element={<SegmentDiscountView />}></Route>
              <Route path='/Master/Miscellaneous/WorkshopDiscountDefinition' element={<WorkshopDiscountDefinition />}></Route>
              <Route path='/Master/Miscellaneous/NONInventoryGRNCreation' element={<NONInventoryGRNCreation />}></Route>
              <Route path='/Master/Miscellaneous/CollateralReallocationApproval' element={<CollateralReallocationApproval />}></Route>
              <Route path='/Master/Miscellaneous/ForecastUpload' element={<ForecastUpload />}></Route>
              <Route path='/Master/Miscellaneous/CensusGeographyUpload' element={<CensusGeographyUpload />}></Route>
              <Route path='/Master/Miscellaneous/CreditNoteAdjustmentRestrictionMapping' element={<CreditNoteAdjustmentMap />}></Route>
              <Route path='/Master/Miscellaneous/RedeemedCouponTransfer' element={<RedeemedCouponTransfer />}></Route>
              <Route path='/Master/Miscellaneous/HD-ILSDiscountDefinitionReport' element={<HDILSDiscountDefinition />}></Route>
              <Route path='/Master/Miscellaneous/ProductBranding' element={
                <SafetyTickerProvider>
                  <SafetyTicker />
                </SafetyTickerProvider>
              }></Route>
              <Route path='/Master/Miscellaneous/ProductBranding/View' element={
                <SafetyTickerProvider>
                  <SafetyTickerView />
                </SafetyTickerProvider>}></Route>
              <Route path='/Master/Miscellaneous/SalesTeamMaster' element={<SalesTeamMaster />}></Route>
              <Route path='/Master/Miscellaneous/SalesTeamMaster/View' element={<SalesTeamMasterView />}></Route>
              <Route path='/Master/Miscellaneous/SalesTeamMaster/Mapping' element={<Mapping />}></Route>
              <Route path='/Master/Miscellaneous/SalesTeamMapping' element={<SalesTeamMapping />}></Route>
              <Route path='/Master/Miscellaneous/WorkshopDiscountRestrictionMapping' element={<WorkshopDiscountRestrictionMapping />}></Route>
              {/* Miscellaneous End */}

              {/* Printing Start */}
              <Route
                path="/Master/Printing/PrintMessageDefinition"
                element={<PrintMessageDefinition />}
              ></Route>
              <Route
                path="/Master/Printing/PrintMessageDefinition/View"
                element={<PrintMessageDefinitionView />}
              ></Route>
              <Route
                path="/Master/Printing/PrintMessageTranslation"
                element={<PrintMessageTranslation />}
              ></Route>
              {/* Printing End */}

              {/* SSR Start */}
              <Route path="/Masters/SSR/SSRType" element={<SSRType />}></Route>
              <Route
                path="/Masters/SSR/CreateSSR"
                element={<CreateSSR />}
              ></Route>
              <Route
                path="/Masters/SSR/CreateSSR/View"
                element={<CreateSSRView />}
              ></Route>
              <Route
                path="/Master/SSR/SSRMasterReport"
                element={<SSRMasterReport />}
              ></Route>
              <Route
                path="/Master/SSR/SSRTownMappingReport"
                element={<SSRTownMappingReport />}
              ></Route>
              <Route
                path="/Master/SSR/ServiceInvoiceApproval"
                element={<ServiceInvoiceApproval />}
              ></Route>
              <Route
                path="/Master/SSR/SSRIncentiveMapping"
                element={<SSRIncentiveMapping />}
              ></Route>
              <Route
                path="/Master/SSR/SSRToTownMapping"
                element={<SSRToTownMapping />}
              ></Route>
              <Route
                path="/Master/SSR/SSRApproval"
                element={<SSRApproval />}
              ></Route>
              {/* SSR End */}

              {/* Others Start */}
              <Route
                path="/Master/TownDefinition"
                element={<TownDefinition />}
              ></Route>
              <Route
                path="/Master/TownDefinition/View"
                element={<TownDefinitionView />}
              ></Route>
              <Route
                path="/Master/TownBulkUpload"
                element={<TownBulkUpload />}
              ></Route>
              <Route
                path="/Master/CMTEmployeeMaster"
                element={<CMTEmployeeMaster />}
              ></Route>
              <Route
                path="/Master/PriceVariation"
                element={<PriceVariation />}
              ></Route>
              {/* Others End */}

              {/* MASTER LAYOUT END HERE */}

              {/* USER MANAGEMENT LAYOUT START HERE */}
              <Route
                path="/UserManagement/CastrolUser"
                element={<CastrolUser />}
              ></Route>
              <Route
                path="/UserManagement/CastrolUser/View"
                element={<CastrolUserView />}
              ></Route>
              <Route
                path="/UserManagement/CastrolEmployee"
                element={<CastrolEmployee />}
              ></Route>
              <Route
                path="/UserManagement/CastrolEmployee/View"
                element={<CastrolEmployeeView />}
              ></Route>
              <Route
                path="/UserManagement/CastrolQuarterConfiguration"
                element={<CastrolQuarterConfig />}
              ></Route>
              <Route
                path="/UserManagement/VendorMaster"
                element={<VendorMaster />}
              ></Route>
              <Route
                path="/UserManagement/VendorMaster/View"
                element={<VendorMasterView />}
              ></Route>
              <Route
                path="/UserManagement/CastrolUserGroup"
                element={<CastrolUserGroup />}
              ></Route>
              <Route
                path="/UserManagement/CastrolUserGroup/View"
                element={<CastrolUserGroupView />}
              ></Route>
              <Route
                path="/UserManagement/CastrolUserGroup/Privilege"
                element={<Privilege />}
              ></Route>
              {/* USER MANAGEMENT LAYOUT END HERE */}

              {/* INTERFACES / OUTPUTS LAYOUT START HERE */}
              <Route
                path="/InterfacesOutputs/SegmentChannelMapping"
                element={<SegmentChannelMapping />}
              ></Route>
              <Route
                path="/InterfacesOutputs/TargetSettings"
                element={<TargetSettings />}
              ></Route>
              <Route
                path="/InterfacesOutputs/DSRUpload"
                element={<DSRUpload />}
              ></Route>
              <Route
                path="/InterfacesOutputs/RuralKYCSegmentMapping"
                element={<RuralKYCSegmentMapping />}
              ></Route>
              <Route
                path="/InterfacesOutputs/OEMInterface/OEMMappingUpload"
                element={<OEMMappingUpload />}
              ></Route>
              <Route
                path="/InterfacesOutputs/OEMInterface/OEMMasterSegmentMapping"
                element={<OEMMasterSegmentMapping />}
              ></Route>
              <Route
                path="/InterfacesOutputs/OEMInterface/OEMErrorDownload"
                element={<OEMErrorDownload />}
              ></Route>
              <Route
                path="/InterfacesOutputs/OEMInterface/RILAMMaster"
                element={<RILAMMaster />}
              ></Route>
              <Route
                path="/InterfacesOutputs/OEMInterface/SpecialPricesUpload"
                element={<SpecialPricesUpload />}
              ></Route>
              <Route
                path="/InterfacesOutputs/FreeProducts"
                element={<FreeProducts />}
              ></Route>
              <Route
                path="/InterfacesOutputs/HolidayList"
                element={<HolidayList />}
              ></Route>
              <Route
                path="/InterfacesOutputs/FOCCreation"
                element={<FOCCreation />}
              ></Route>
              {/* INTERFACES / OUTPUTS LAYOUT END HERE */}

              {/* QRM LAYOUT START HERE */}
              <Route path="/QRM/CNApproval" element={<CNApproval />}></Route>
              <Route
                path="/QRM/CNApproval/View"
                element={<CNApprovalView />}
              ></Route>
              <Route
                path="/QRM/Reports/QRMStatusReport"
                element={<QRMStatusReport />}
              ></Route>
              <Route
                path="/QRM/Reports/FreezedCNFOCReport"
                element={<FreezedCNFOCReport />}
              ></Route>
              <Route path="/QRM/FOCApproval" element={<FOCApproval />}></Route>
              <Route
                path="/QRM/FOCApproval/View"
                element={<FOCApprovalView />}
              ></Route>
              {/* QRMT LAYOUT END HERE */}

              {/* HELPDESK LAYOUT START HERE */}
              <Route
                path="/Helpdesk/SurveyForm"
                element={<SurveyForm />}
              ></Route>
              <Route
                path="/Helpdesk/SurveyForm/View"
                element={<SurveyFormView />}
              ></Route>
              <Route
                path="/Helpdesk/IssueLogger"
                element={<IssueLogger />}
              ></Route>
              <Route
                path="/Helpdesk/SLAMonitor"
                element={<SLAMonitor />}
              ></Route>
              <Route
                path="/Helpdesk/SurveyFeedback"
                element={<SurveyFeedback />}
              ></Route>
              {/* HELPDESK LAYOUT END HERE */}

              {/* REPORTS LAYOUT START HERE */}
              <Route path='/Reports/Sales/CreditNoteAdjustmentReport' element={<CreditNoteAdjustment />}></Route>
              <Route path='/Reports/Sales/CombinedReportForUrbanAndRural' element={<CombinedReportForUrbanRural />}></Route>
              <Route path='/Reports/Sales/SalesMonthlyReport' element={<SalesMonthlyReport />}></Route>
              <Route path='/Reports/Sales/InvoiceDataToExcel' element={<InvoiceDataToExcel />}></Route>
              <Route path='/Reports/Sales/InvoiceDataToExcelHOUsers' element={<InvoiceDataToExcelHOUsers />}></Route>
              <Route path='/Reports/Sales/SKUDiscountDataToExcel' element={<SKUDiscountDataToExcel />}></Route>
              <Route path='/Reports/Sales/SalesAgeingReport' element={<SalesAgeingReport />}></Route>
              <Route path='/Reports/Sales/OrderReceivedVsOrderInvoicedReport' element={<OrderReceivedVsOrderInvoiced />}></Route>
              <Route path='/Reports/Sales/SalesPeriodicReport' element={<SalesPeriodicReport />}></Route>
              <Route path='/Reports/Sales/SalesDailyReport' element={<SalesDailyReport />}></Route>
              <Route path='/Reports/Sales/SalesWeeklyReport' element={<SalesWeeklyReport />}></Route>
              <Route path='/Reports/Sales/SalesQuarterlyReport' element={<SalesQuarterlyReport />}></Route>
              <Route path='/Reports/Sales/TownwiseSalesMonthlyReport' element={<TownwiseSalesMonthlyReport />}></Route>
              <Route path='/Reports/Sales/SalesComparisonReport' element={<SalesComparisonReport />}></Route>
              <Route path='/Reports/Stock/GoodsInTransit' element={<GoodsInTransit />}></Route>
              <Route path='/Reports/Stock/StockAdjustment' element={<StockAdjustment />}></Route>
              <Route path='/Reports/Stock/StockDailyDetail' element={<StockDailyDetail />}></Route>
              <Route path='/Reports/Stock/StockInHand' element={<StockInHand />}></Route>
              <Route path='/Reports/Stock/StockMonthlyDetail' element={<StockMonthlyDetail />}></Route>
              <Route path='/Reports/Sales/SalesWeeklyReport' element={<SalesWeeklyReport />}></Route>
              <Route path='/Reports/Sales/SalesQuarterlyReport' element={<SalesQuarterlyReport />}></Route>
              <Route path='/Reports/Sales/TownwiseSalesMonthlyReport' element={<TownwiseSalesMonthlyReport />}></Route>
              <Route path='/Reports/Sales/SalesComparisonReport' element={<SalesComparisonReport />}></Route>
              <Route path='/Reports/GRNDatatoExcel' element={<GRNDatatoExcel />}></Route>
              <Route path='/Reports/GRNDiscountDataToExcel' element={<GRNDiscountDataToExcel />}></Route>
              <Route path='/Reports/ReportValueAccessMapping' element={<ReportValueAccessMapping />}></Route>
              <Route path='/Reports/ChangeRequestReport' element={<ChangeRequestReport />}></Route>
              <Route path='/Reports/ContractPricingReport' element={<ContractPricingReport />}></Route>
              <Route path='/Reports/CouponReportToExcel' element={<CouponReportToExcel />}></Route>
              <Route path='/Reports/CustomerMetricReport' element={<CustomerMetricReport />}></Route>
              <Route path='/Reports/NonInventoryGRNDataToExcel' element={<NonInventoryGRNDataToExcel />}></Route>
              <Route path='/Reports/DeliveryChallanReport' element={<DeliveryChallanReport />}></Route>
              <Route path='/Reports/FOCTrackerReport' element={<FOCTrackerReport />}></Route>
              <Route path='/Reports/FOCReport' element={<FOCReport />}></Route>
              <Route path='/Reports/NonInventoryReport' element={<NonInventoryReport />}></Route>
              <Route path='/Reports/OnInvoiceFOCSchemeReport' element={<AssortMentReport />}></Route>
              <Route path='/Reports/JCB/JCBUserDetailsReport' element={<JCBUserDetails />}></Route>
              <Route path='/Reports/JCB/JCBTransactionalDetailsReport' element={<JCBTransactionalDetails />}></Route>
              <Route path='/Reports/JCB/JCBCouponSearch' element={<JCBCouponSearch />}></Route>
              <Route path='/Reports/JCB/JCBCouponReconciliationReport' element={<JCBCouponReconciliation />}></Route>
              <Route path='/AdminReports/DownloadDetailMonitor' element={<DownloadDetailMonitor />}></Route>
              {/* REPORTS LAYOUT END HERE */}

              {/* PRICE LIST LAYOUT START HERE */}
              <Route
                path="/PriceList/DownloadPriceList"
                element={<DownloadPriceList />}
              ></Route>
              <Route
                path="/PriceList/PriceListUploadTemplate"
                element={<PriceListUploadTemplate />}
              ></Route>
              {/* PRICE LIST LAYOUT END HERE */}

              {/* RURAL LAYOUT START HERE */}
              <Route
                path="/Rural/PIDwiseTargetUpload"
                element={<PIDwiseTargetUpload />}
              ></Route>
              <Route path="/Rural/CSDReports" element={<CSDReports />}></Route>
              <Route
                path="/Rural/RuralTownTagging"
                element={<RuralTownTagging />}
              ></Route>
              <Route
                path="/Rural/StockAdjustmentApprovalForCSD"
                element={<StockAdjustmentApprovalForCSD />}
              ></Route>
              <Route path="/Rural/RSEReports" element={<RSEReports />}></Route>
              <Route
                path="/Rural/CustomerSegmentTownApprovalforCSD/SegmentChangeReactivationApprovalForCSD"
                element={<SegmentChangeReactivationApprovalForCSD />}
              ></Route>
              <Route
                path="/Rural/RSECustomerReport"
                element={<RSECustomerReport />}
              ></Route>
              {/* RURAL LAYOUT START HERE */}

              {/* SGR BRAND LAYOUT START HERE */}
              <Route
                path="/SGRBrand/SGRBrandEligibility"
                element={<SGRBrandEligibility />}
              ></Route>
              <Route
                path="/SGRBrand/SGRBrandDataView"
                element={<SGRBrandDataView />}
              ></Route>
              <Route
                path="/SGRBrand/SGRBrandDataViewPreview"
                element={<SGRBrandDataViewPreview />}
              ></Route>
              {/* SGR BRAND LAYOUT START HERE */}

              {/* RNR START HERE */}
              <Route path="/RNR/AudienceDefinition" element={<AudienceDefinition />} />
              <Route path="/RNR/ChannelDefinition" element={<ChannelDefinition />} />
              <Route path="/RNR/LBMDefinition" element={<LBMDefinition />} />
              <Route path="/RNR/CategoryHeadLvlMaxDisc" element={<CategoryHeadLvlMaxDisc />} />
              <Route path="/RNR/DBDiscFactorMapping" element={<DBDiscFactorMapping />} />
              <Route path="/RNR/CategoryStreamMapping" element={<CategoryStreamMapping />} />
              <Route path="/RNR/ChannelCategoryUserMapping" element={<ChannelCategoryUserMapping />} />
              <Route path="/RNR/ChannelDefUserMapping" element={<ChannelDefUserMapping />} />
              <Route path="/RNR/ChannelOutletMapping" element={<ChannelOutletMapping />} />
              <Route path="/RNR/DBToCategoryMapping" element={<DBToCategoryMapping />} />
              <Route path="/RNR/IndustrialDBTurnOverUpload" element={<IndustrialDBTurnOverUpload />} />
              <Route path="/RNR/RewardsRebateStatusReport" element={<RewardsRebateStatusReport />} />
              <Route path="/RNR/AllCategoryRecord" element={<AllCategoryRecord />} />
              <Route path="/RNR/ASMRSMApprovalDBScoreCrad" element={<ASMRSMApprovalDBScoreCrad />} />
              <Route path="/RNR/RSMPlanningToolDBScorecard" element={<RSMPlanningToolDBScorecard />} />
              <Route path="/RNR/ASMPlaningToolDBScoreCard" element={<ASMPlaningToolDBScoreCard />} />
              <Route path="/RNR/ASMPlanningAllRecords" element={<ASMPlanningAllRecords />} />
              <Route path="/RNR/RSMPlanningAllRecords" element={<RSMPlanningAllRecords />} />
              <Route path="/RNR/ASMRSMApprovalAllRecords" element={<ASMRSMApprovalAllRecords />} />
              <Route path="/RNR/CategoryDefinition" element={<CategoryDefinition />} />
              <Route path="/RNR/RNRPayoutReport" element={<RNRPayoutReport />} />
              {/* RNR END HERE */}

              {/* DB SIP START HERE */}
              <Route path='/DBSIP/Construct' element={<AllConstructRecors />}></Route>
              <Route path='/DBSIP/NewConstruct' element={<Construct />}></Route>
              <Route path='/DBSIP/DBSIPReport' element={<DBSIPReport />}></Route>
              <Route path='/DBSIP/ExceptionHandling' element={<ExceptionHandling />}></Route>
              <Route path='/DBSIP/LBMBrandMapping' element={<LBMBrandMapping />}></Route>
              <Route path='/DBSIP/DBSIPRawData' element={<DBSipRawData />}></Route>
              <Route path='/DBSIP/FocusBrandTargetGrowth' element={<FocusBrandTargetGrowth />}></Route>
              <Route path='/DBSIP/VolumeDefinition' element={<VolumeDefinitionDistribution />}></Route>
              <Route path='/DBSIP/ThresholdRestriction' element={<ThresholdRestriction />}></Route>
              <Route path='/DBSIP/SIPUpload' element={<SIPUpload />}></Route>
              <Route path='/DBSIP/NewAccountUpload' element={<NewAccountUpload />}></Route>
              <Route path='/DBSIP/SIPReProcess' element={<SIPReProcess />}></Route>
              <Route path='/DBSIP/CorrectedActualUpload' element={<CorrectedActualUpload />}></Route>
              <Route path='/DBSIP/SIPWeekDefinition' element={<SIPWeekDefinition />}></Route>
              <Route path='/DBSIP/CoreNonCoreTownMapping' element={<CoreNonCoreTownMapping />}></Route>
              {/* DB SIP END HERE */}

              {/* INVENTORY MANAGEMENT LAYOUT START HERE */}
              <Route
                path="/InventoryManagement/ABCView"
                element={<ABCView />}
              ></Route>
              <Route
                path="/InventoryManagement/ABCDefinition"
                element={<ABCDefinition />}
              ></Route>
              <Route
                path="/InventoryManagement/APlusProduct"
                element={<APlusProduct />}
              ></Route>
              <Route
                path="/InventoryManagement/StockNorm"
                element={<StockNorm />}
              ></Route>
              <Route
                path="/InventoryManagement/StockAdjustmentApproval"
                element={<StockAdjustmentApproval />}
              ></Route>
              <Route
                path="/InventoryManagement/NormWeightageSetting"
                element={<NormWeightageSetting />}
              ></Route>
              <Route
                path="/InventoryManagement/NewProductIntroduction"
                element={<NewProductIntroduction />}
              ></Route>
              <Route
                path="/InventoryManagement/NormCalculationProcess"
                element={<NormCalculationProcess />}
              ></Route>
              <Route
                path="/InventoryManagement/CFAPromoMapping"
                element={<CFAPromoMapping />}
              ></Route>
              <Route
                path="/InventoryManagement/StockNormBulkUpload"
                element={<StockNormBulkUpload />}
              ></Route>
              <Route
                path="/InventoryManagement/NormParameter"
                element={<NormParameter />}
              ></Route>
              <Route
                path="/InventoryManagement/PurchaseOrderGeneration"
                element={<PurchaseOrderGeneration />}
              ></Route>
              <Route
                path="/InventoryManagement/Collateral/CollateralDestroyApproval"
                element={<DestroyApproval />}
              ></Route>
              <Route
                path="/InventoryManagement/Collateral/CollateralDispatchAddressReport"
                element={<DispatchAddressReport />}
              ></Route>
              <Route
                path="/InventoryManagement/Collateral/CollateralNonInventoryCategoryMaster"
                element={<NonInventoryCategoryMaster />}
              ></Route>
              <Route
                path="/InventoryManagement/Collateral/CollateralStatusDashboard"
                element={<StatusDashboard />}
              ></Route>
              {/* INVENTORY MANAGEMENT LAYOUT START HERE */}

              {/* ADMIN REPORTS LAYOUT START HERE */}
              <Route path="/AdminReports" element={<AdminReports />}></Route>
              {/* ADMIN REPORTS LAYOUT START HERE */}

              {/* DISTRIBUTOR ONBOARDING LAYOUT START HERE */}
              <Route
                path="/DistributorsOnboarding/DistributorsOnboarding"
                element={<DistributorsOnboarding />}
              />
              <Route
                path="/DistributorsOnboarding/DistributorsOnboarding/View"
                element={<DistributorsOnboardingView />}
              />

              {/* BANNER UPLOAD LAYOUT START HERE */}
              <Route path='/BannerUpload/CSD' element={<BannerUploadCSD />}></Route>
              <Route path='/BannerUpload/CSD/View' element={<BannerUploadCSDView />}></Route>
              <Route path='/BannerUpload/DB' element={<BannerUploadDB />}></Route>
              <Route path='/BannerUpload/DB/View' element={<BannerUploadDBView />}></Route>
              {/* BANNER UPLOAD LAYOUT START HERE */}

              {/* AUTOMOTIVE MANUAL BILLING LAYOUT START HERE */}
              <Route
                path="/ManualBilling"
                element={<AutomotiveManualBilling />}
              ></Route>
              {/* AUTOMOTIVE MANUAL BILLING LAYOUT START HERE */}

              {/* SURCHARGE DEFINITION LAYOUT START HERE */}
              <Route path='/Master/SurchargeDefinition' element={<SurchargeDefAllRecords />}></Route>
              <Route path='/Master/SurchargeDefinition/View' element={<SurchargeDefinition />}></Route>
              {/* SURCHARGE DEFINITION LAYOUT END HERE */}
              {/* CUSTOMER UPLOAD VIEW START HERE */}
              <Route path='/Master/Miscellaneous/AppSettings/CustomerUploadSecondary' element={<CustomerUploadDB />}></Route>
              <Route path='/Master/Miscellaneous/AppSettings/CustomerUploadTertiary' element={<CustomerUploadCSD />}></Route>
              {/* CUSTOMER UPLOAD VIEW START HERE */}
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
